import type { InvoiceStatus } from '../type/types';

const KNOWN_INVOICE_STATUSES: readonly InvoiceStatus[] = [
    'Draft',
    'Sent',
    'Expired',
    'Declined',
    'Cancelled',
    'Accepted',
    'Issued',
    'PartialPaid',
    'Paid',
    'Overdue',
    'RequestCancellation',
    'Refunded',
];

/**
 * Mirrors Invoice::isQuote() in PHP — quote phase is Draft, Sent, Expired, or Declined.
 * {@code quoteDecisionDate} is unused; kept so existing call sites compile.
 */
export const isInvoiceQuote = (
    status: string | null | undefined,
    _quoteDecisionDate?: string | null,
): boolean => {
    if (status == null || status === '') {
        return true;
    }
    if (['Draft', 'Sent', 'Expired', 'Declined'].includes(status)) {
        return true;
    }
    if (!KNOWN_INVOICE_STATUSES.includes(status as InvoiceStatus)) {
        return true;
    }
    return false;
};

/** Proposal UI document label: quote vs invoice, aligned with isInvoiceQuote. */
export const getDocType = (
    status: InvoiceStatus,
    quoteDecisionDate?: string | null,
): 'quote' | 'invoice' =>
    isInvoiceQuote(status, quoteDecisionDate) ? 'quote' : 'invoice';
